var parseSampleFlags = function(flags) {
  return {
    isLeading: (flags[0] & 0x0c) >>> 2,
    dependsOn: flags[0] & 0x03,
    isDependedOn: (flags[1] & 0xc0) >>> 6,
    hasRedundancy: (flags[1] & 0x30) >>> 4,
    paddingValue: (flags[1] & 0x0e) >>> 1,
    isNonSyncSample: flags[1] & 0x01,
    degradationPriority: (flags[2] << 8) | flags[3]
  };
};

module.exports = parseSampleFlags;



//////////////////
// WEBPACK FOOTER
// /Users/hynek/Work/localhost/malcom/wp-content/themes/malcom/node_modules/mux.js/lib/tools/parse-sample-flags.js
// module id = 117
// module chunks = 0